import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Tabs, Tab } from 'react-tabs-scrollable'
import 'react-tabs-scrollable/dist/rts.css'

import Tooltip from 'components/Shared/Tooltip/Index'
import IconLink from 'components/Shared/IconLink/Index'
import TabsStyles from './TabsStyles'
import TabItem from './TabItem'

const StyledWrapper = styled.div`
  ${TabsStyles}
`

const LeftArrow = () => {
  const { t } = useTranslation()
  return (
    <>
      <IconLink
        iconName='icon-backward'
        data-tooltip-content={t('common.tooltipShowMore')}
        data-tooltip-id='tabs-tooltip-left'
      />
      <Tooltip id='tabs-tooltip-left' />
    </>
  )
}

const RightArrow = () => {
  const { t } = useTranslation()
  return (
    <>
      <IconLink
        iconName='icon-forward'
        data-tooltip-content={t('common.tooltipShowMore')}
        data-tooltip-id='tabs-tooltip-right'
      />
      <Tooltip id='tabs-tooltip-right' />
    </>
  )
}

const ScrollableTabs = ({ items, activeTabIndex, onTabClick }) => {
  const [activeTabIndex_, setActiveTabIndex_] = useState(activeTabIndex || 0)

  useEffect(() => {
    setActiveTabIndex_(activeTabIndex)
  }, [activeTabIndex])

  const onTabClick_ = (e, index) => {
    setActiveTabIndex_(index)
    onTabClick?.(index, items[index])
  }

  return (
    <StyledWrapper>
      <Tabs
        activeTab={activeTabIndex_}
        onTabClick={onTabClick_}
        hideNavBtnsOnMobile={false}
        leftBtnIcon={<LeftArrow />}
        rightBtnIcon={<RightArrow />}
      >
        {items.map((itemInfo, index) => {
          const isActive = Boolean(index === activeTabIndex_)
          return (
            <Tab key={index}>
              <TabItem itemInfo={itemInfo} isActive={isActive} />
            </Tab>
          )
        })}
      </Tabs>
    </StyledWrapper>
  )
}

ScrollableTabs.propTypes = {
  items: PropTypes.array.isRequired,
  activeTabIndex: PropTypes.number.isRequired,
  onTabClick: PropTypes.func,
}

export default ScrollableTabs
